import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "@/App.css";

import Home from "@/pages/Home";
import Plots from "@/pages/Plots";
import Gallery from "@/pages/Gallery";
import Schemes from "@/pages/Schemes";
import Finance from "@/pages/Finance";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Calculator from "@/pages/Calculator";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ComparisonPage from "@/pages/ComparisonPage";
import VirtualTour from "@/pages/VirtualTour";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppButton from "@/components/WhatsAppButton";
import AIChatWidget from "@/components/AIChatWidget";
import GAScript from "@/components/GAScript";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("admin_token");
  return token ? children : <Navigate to="/admin" replace />;
}

function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);
  return children;
}

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
    <SmoothScroll>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/plots" element={<Plots />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/schemes" element={<Schemes />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/kotdwar-vs-delhi-ncr" element={<ComparisonPage />} />
          <Route path="/virtual-tour" element={<VirtualTour />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <WhatsAppButton />
        <AIChatWidget />
        <GAScript />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </SmoothScroll>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
